import { useMutation, useQueryClient } from '@tanstack/react-query';

import { parseApiError, getApiClient } from '@cast/api-client';
import { notify } from '@cast/design-system';

import { getDiscountsQueryKey } from './useDiscountsQuery';

export const useDeleteDiscountMutation = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: ({ discountId }: { discountId: string }) =>
      getApiClient().discounts.deleteDiscount({ discountId }),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: getDiscountsQueryKey() });
      notify.success('Price adjustment deleted');
    },
    onError: (error) => {
      notify.error(parseApiError(error));
    },
  });
};
